import { profileFieldQueries } from "@circle-react/lib/queries/profileFields";
import { useQuery } from "react-query";

import { DISPLAY_OPTION_FIELD_INPUTS } from "@/react/components/shared/ProfileFields/constants";

export const useIsBioVisibleInProfileView = (): boolean => {
  const { data: bioField } = useQuery({
    ...profileFieldQueries.byKey("bio"),
    retry: false,
  });

  if (!bioField || bioField.archived) return false;

  const profileViewPage = bioField.pages?.find(
    page => page.name === DISPLAY_OPTION_FIELD_INPUTS.PROFILE_VIEW,
  );
  return profileViewPage?.visible === true;
};
